
export const auth = {
  AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
  AUTH_LOGIN_ERROR: 'AUTH_LOGIN_ERROR',
  AUTH_LOGIN_PENDING: 'AUTH_LOGIN_PENDING',
  AUTH_LOGOUT_SUCCESS: 'AUTH_LOGOUT_SUCCESS',
  AUTH_LOGOUT_ERROR: 'AUTH_LOGOUT_ERROR',
  AUTH_LOGOUT_PENDING: 'AUTH_LOGOUT_PENDING',
  AUTH_AUTHORISE_SUCCESS: 'AUTH_AUTHORISE_SUCCESS',
  AUTH_AUTHORISE_ERROR: 'AUTH_AUTHORISE_ERROR',
  AUTH_AUTHORISE_PENDING: 'AUTH_AUTHORISE_PENDING',
  AUTH_REGISTER_SUCCESS: 'AUTH_REGISTER_SUCCESS',
  AUTH_REGISTER_ERROR: 'AUTH_REGISTER_ERROR',
  AUTH_REGISTER_PENDING: 'AUTH_REGISTER_PENDING',
}

export const getPaymentMethods = {
  GET_PAYMENT_METHODS_SUCCESS: 'GET_PAYMENT_METHODS_SUCCESS',
  GET_PAYMENT_METHODS_ERROR: 'GET_PAYMENT_METHODS_ERROR',
  GET_PAYMENT_METHODS_PENDING: 'GET_PAYMENT_METHODS_PENDING',
}

export const deletePaymentMethod = {
  DELETE_PAYMENT_METHOD_SUCCESS: 'DELETE_PAYMENT_METHOD_SUCCESS',
  DELETE_PAYMENT_METHOD_ERROR: 'DELETE_PAYMENT_METHOD_ERROR',
  DELETE_PAYMENT_METHOD_PENDING: 'DELETE_PAYMENT_METHOD_PENDING',
}

export const addPaymentMethod = {
  ADD_PAYMENT_METHOD_SUCCESS: 'ADD_PAYMENT_METHOD_SUCCESS',
  ADD_PAYMENT_METHOD_ERROR: 'ADD_PAYMENT_METHOD_ERROR',
  ADD_PAYMENT_METHOD_PENDING: 'ADD_PAYMENT_METHOD_PENDING',
}

export const settings = {
  UPDATE_SETTINGS_SUCCESS: 'UPDATE_SETTINGS_SUCCESS',
  UPDATE_SETTINGS_ERROR: 'UPDATE_SETTINGS_ERROR',
  UPDATE_SETTINGS_PENDING: 'UPDATE_SETTINGS_PENDING',
}

export const deleteAccount = {
  DELETE_ACCOUNT_SUCCESS: 'DELETE_ACCOUNT_SUCCESS',
  DELETE_ACCOUNT_ERROR: 'DELETE_ACCOUNT_ERROR',
  DELETE_ACCOUNT_PENDING: 'DELETE_ACCOUNT_PENDING',
}

export const downloadAccess = {
  GET_DOWNLOAD_ACCESS_SUCCESS: 'GET_DOWNLOAD_ACCESS_SUCCESS',
  GET_DOWNLOAD_ACCESS_ERROR: 'GET_DOWNLOAD_ACCESS_ERROR',
  GET_DOWNLOAD_ACCESS_PENDING: 'GET_DOWNLOAD_ACCESS_PENDING',
}